import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { TooltipItem, TOOLTIPS } from '@app/core/const/tooltips';
import * as fromRoot from '@app/store/reducers';
import { TranslocoService } from '@jsverse/transloco';
import { select, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

@Component({
  selector: 'am-tooltip-modal',
  templateUrl: './tooltip-modal.component.html',
  styleUrls: ['./tooltip-modal.component.scss'],
  imports: [MatIcon, MatDialogClose, MatDialogTitle, CdkScrollable, MatDialogContent],
  standalone: true,
})
export class TooltipModalComponent implements OnInit {
  tooltipId = inject(MAT_DIALOG_DATA);

  tooltips: TooltipItem[];
  title: string;

  private readonly _store = inject<Store<fromRoot.State>>(Store);
  private readonly _translocoService = inject(TranslocoService);

  ngOnInit(): void {
    this._store.pipe(select(fromRoot.getCurrentLang), take(1)).subscribe(currentLang => {
      const tooltipsData = TOOLTIPS.find(tooltips => tooltips.displayedOn === this.tooltipId);
      this.tooltips = tooltipsData
        ? tooltipsData[currentLang].tooltips
        : [{ word: '', definition: this._translocoService.translate('shared.tooltip-modal.no-definition') }];
      this.title = tooltipsData
        ? tooltipsData[currentLang].title
        : this._translocoService.translate('shared.tooltip-modal.error-title');
    });
  }
}
